import { ChangeDetectorRef, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TopBarAppComponent, TopBarComponentBase } from '@dimandzhi/top-bar';
import { environment as env } from 'environments/environment';
import { KeycloakService } from 'keycloak-angular-26';
import moment from 'moment-timezone';
import { ErrorDialog } from './c/error-dialog/error-dialog';
import { DataService } from './s/data.service';
import { StyleManagerService } from './s/style-manager/style-manager.service';

@Component({ template: `` })
export class TopBarComponent extends TopBarComponentBase {
  @ViewChild('topBarControls') topBarControls: TemplateRef<any>; // Required to load controls

  constructor(changeDetector: ChangeDetectorRef) {
    super(changeDetector);
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends TopBarAppComponent {
  title = 'app';
  @Input() topBarControls: TemplateRef<any>;

  constructor(
    private data: DataService,
    public keycloak: KeycloakService,
    changeDetector: ChangeDetectorRef,
    private dialog: MatDialog,
    public styleManager: StyleManagerService
  ) {
    super(changeDetector, env.production);
    moment.locale('en');
    moment.tz.setDefault('Europe/Warsaw');
  }

  themeChangeHandler(themeToSet: string) {
    this.styleManager.setTheme(themeToSet);
  }

  ngOnInit(): void {
    this.data.error.subscribe((nextErr) => {
      this.dialog.open(ErrorDialog, { data: nextErr });
    });
  }

  logout() {
    this.keycloak.logout(window.location.href);
  }
}
